<template>
    <div>
        <div class="app-info" v-if="personalInfo?.personalInformation">
            <div>
                <div class="app-info-row">
                    <div class="app-info-group">
                        <label for="lastName">Last name</label>
                        <span for="lastNameText">{{ personalInfo.personalInformation.lastName }}</span>
                    </div>
                    <div class="app-info-group">
                        <label for="firstName">First name</label>
                        <span for="firstNameText">{{ personalInfo.personalInformation.firstName }}</span>
                    </div>
                    <div class="app-info-group">
                        <label for="middleName">Middle name</label>
                        <span for="middleNameText">{{ personalInfo.personalInformation.middleName || ' ' }}</span>
                    </div>
                    <div class="app-info-group">
                        <label for="suffix">Suffix</label>
                        <span for="suffixText">{{ personalInfo.personalInformation.suffix || ' ' }}</span>
                    </div>
                    <div class="app-info-group">
                        <label for="dateOfBirth">Date of birth</label>
                        <span for="dateOfBirthText">{{ personalInfo.personalInformation.dateOfBirth }}</span>
                    </div>
                    <div class="app-info-group">
                        <label for="gender">Gender</label>
                        <span for="genderText">{{ personalInfo.credentialInformation?.gender }}</span>
                    </div>
                </div>
                <div class="app-info-row" v-if="personalInfo.personalInformation.physicalAddress">
                    <div class="info-box">
                        <div class="user-info">
                            <span class="user-address-info">Physical address</span>
                            <span>{{ personalInfo.personalInformation.physicalAddress.addressLine1 }}</span>
                            <span>{{ personalInfo.personalInformation.physicalAddress.addressLine2 }}</span>
                            <span>
                                {{ personalInfo.personalInformation.physicalAddress.city }},
                                {{
                                    personalInfo.personalInformation.physicalAddress.addressType === 'Us Domestic' ?
                                        personalInfo.personalInformation.physicalAddress.state :
                                        personalInfo.personalInformation.physicalAddress.province
                                }},
                                {{ personalInfo.personalInformation.physicalAddress.country }}
                            </span>
                            <span>
                                {{
                                    personalInfo.personalInformation.physicalAddress.addressType === 'Us Domestic' ?
                                        personalInfo.personalInformation.physicalAddress.zipPlus === '' ?  personalInfo.personalInformation.physicalAddress.zipCode :
                                        `${personalInfo.personalInformation.physicalAddress.zipCode} - ${personalInfo.personalInformation.physicalAddress.zipPlus}`
                                        : `${personalInfo.personalInformation.physicalAddress.internationalZipCode}`
                                }}
                            </span>
                            <div v-if="mfaType!=4">
                                <router-link :to="{ name: 'UpdateAddress' }">Update my address</router-link>
                            </div>
                        </div>
                        <div class="user-info">
                            <span class="user-address-info">Mailing address</span>
                            <span>{{ personalInfo.personalInformation.mailingAddress?.addressLine1 }} </span>
                            <span>{{ personalInfo.personalInformation.mailingAddress?.addressLine2 }}</span>
                            <span>
                                {{ personalInfo.personalInformation.mailingAddress?.city }},
                                {{
                                    personalInfo.personalInformation.mailingAddress?.addressType === 'Us Domestic' ?
                                        personalInfo.personalInformation.mailingAddress?.state :
                                        personalInfo.personalInformation.mailingAddress?.province
                                }},
                                {{ personalInfo.personalInformation.mailingAddress?.country }}
                            </span>
                            <span>
                                {{
                                    personalInfo.personalInformation.mailingAddress?.addressType === 'Us Domestic' ?
                                        personalInfo.personalInformation.mailingAddress?.zipPlus === '' ? personalInfo.personalInformation.mailingAddress?.zipCode :
                                        `${personalInfo.personalInformation.mailingAddress?.zipCode} - ${personalInfo.personalInformation.mailingAddress?.zipPlus}`
                                        : `${personalInfo.personalInformation.mailingAddress?.internationalZipCode}`
                                }}
                            </span>
                        </div>
                        <div class="user-info">
                            <span class="contact-info">Contact information</span>
                            <div class="verify-email">
                                <span class="user-info-email">{{ personalInfo.personalInformation.email || 'No email on file' }}</span>
                                <img v-if="personalInfo.personalInformation.isEmailVerified" class="verify-icon" src="/static/verified-icon.png" alt="Email is verified">
                            </div>
                            <div class="verify-phone">
                                <span>{{ personalInfo.personalInformation.phone || 'No phone on file' }}</span>
                                <img v-if="personalInfo.personalInformation.isPhoneVerified" class="verify-icon" src="/static/verified-icon.png" alt="Phone is verified">
                            </div>
                            <div v-if="mfaType != 4">
                                <button type="button" @click="handleStandardContactUpdate" class="link-button">
                                    Update / Verify my contact information
                                </button>
                            </div>
                        </div>
                        <div class="user-info">
                            <label for="donor">Organ donor</label>
                            <span for="donorText">{{ personalInfo.credentialInformation?.organDonor }}</span>
                        </div>

                        <div class="user-info" v-if="personalInfo.paperlessEnrollmentInformation?.displayPaperlessEnrollment === 'Yes' ">
                            <span class="comm-text">Paperless enrollment
                                <span>
                                    <Tooltip theme="my-custom-tooltip" :triggers="['hover', 'click', 'focus']">
                                        <button type="button" class="btn-tooltip-trigger" aria-label="Paperless Notice Details">
                                            <img src="@ridmv/web-themes/images/icons/question-circle-solid.svg" alt="Description" class="comm-tooltip">
                                        </button>  
                                        <template #popper>
                                            With paperless enrollment you will start receiving official DMV notices by email instead of paper notices by US mail. <br />
                                            RI DMV is implementing paperless notices in a phased manner. After you opt-in for paperless communication you may still receive some RI DMV notices by paper. <br />
                                            <br />
                                            Below are the notices that you will receive paperless notices for, rest will be received by US mail until all notices are paperless <br />
                                            <ul>
                                                <li>
                                                    1. CDL Renewal Notice
                                                </li>
                                                <li>
                                                    2. CDL Hazmat Renewal Notice
                                                </li>
                                            </ul>
                                            <span class="sr-only">With paperless enrollment you will start receiving official DMV notices by email instead of paper notices by US mail. <br />
                                                RI DMV is implementing paperless notices in a phased manner. After you opt-in for paperless communication you may still receive some RI DMV notices by paper. <br />
                                                Below are the notices that you will receive paperless notices for, rest will be received by US mail until all notices are paperless <br />
                                                <ul>
                                                    <li>
                                                        1. CDL Renewal Notice
                                                    </li>
                                                    <li>
                                                        2. CDL Hazmat Renewal Notice
                                                    </li>
                                                </ul>
                                            </span>
                                        </template>
                                    </Tooltip>
                                </span>
                            </span>
                            <div>
                                <div class="app-communication">
                                    <span>{{ personalInfo.paperlessEnrollmentInformation?.paperlessEnrollment === 'Yes' ? 'Yes' : 'No' }} </span><span class="comm-notenrolled" v-if="personalInfo.paperlessEnrollmentInformation?.paperlessEnrollment !=='Yes'">Go Green, Go Paperless</span>
                                </div>
                                <div>
                                    <button type="button" @click="handleUpdateCommunicationClick" class="link-button">
                                        Update my paperless enrollment
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="res-display">
                        <span class="res-notification">Upcoming DMV Reservations</span>
                        <Tooltip theme="my-custom-tooltip" :triggers="['hover', 'click', 'focus']">
                            <input
                                type="image"
                                src="/static/RefreshBtn.png"
                                class="refresh-icon app-tooltip"
                                tabindex="0"
                                alt="Click Refresh to view updated reservation information"
                                @click="getRefresh()"
                            />
                            <span class="sr-only">Click Refresh to view updated reservation information</span>
                            <template #popper>
                                Click Refresh to view updated reservation information
                            </template>
                        </Tooltip>
                    </div>
                    <div class="upcoming-res">
                        <div class="app-info-row app-reservations" v-if="personalInfo.reservationInformation && personalInfo.reservationInformation.length > 0">
                            <div class="user-reservations" v-for="(reservationInformation, i) in personalInfo.reservationInformation" :key="i">
                                <div class="app-info-group user-res-details">
                                    <span class="res-details">Service</span>
                                    <span>{{ reservationInformation.visitType }}</span>
                                </div>
                                <div class="app-info-group user-res-details">
                                    <span class="res-details">Confirmation number</span>
                                    <span>{{ reservationInformation.appointmentNumber }}</span>
                                </div>
                                <div class="app-info-group user-res-details">
                                    <span class="res-details">Date and time</span>
                                    <span>{{ formatWeekday(reservationInformation.scheduleDate) }}</span>
                                    <span>{{ formatMonthDayYear(reservationInformation.scheduleDate) }}</span>
                                    <span>{{ formatTime(reservationInformation.scheduleTime) }}</span>
                                </div>
                                <div class="app-info-group user-res-details">
                                    <span class="res-details">Location</span>
                                    <span>{{ reservationInformation.location }}</span>
                                </div>
                                <a href="#" @click.prevent="modifyReservation(reservationInformation.appointmentNumber)">Modify / Cancel Reservation </a>
                            </div>
                        </div>
                        <!-- "no-reservation" block -->
                        <div class="no-reservation" v-else>
                            <span>No upcoming reservation(s) to show.</span>
                        </div>
                    </div>
                </div>
                <!-- "blocks" block -->
                <div class="app-notice app-info-row" v-if="personalInfo?.blocksInformation?.length > 0">
                    <div class="blocks-info">
                        <img class="active-icon" src="/static/activeBlocks.svg" alt="Icon" />
                        <b>You have the following block(s):</b>
                    </div>
                    <ul>
                        <li v-for="(item, p) in personalInfo.blocksInformation" :key="`action${p}`">
                            <template v-if="item.actionUrl && item.actionId == '9'">
                                <span>
                                {{ splitInstructionForLink(item.actionInstruction).before }}

                                <a :href="item.actionUrl" target="_blank">
                                    {{ splitInstructionForLink(item.actionInstruction).match }}
                                    <LinkOpenNewSr />
                                </a>
                                {{ splitInstructionForLink(item.actionInstruction).after }}
                                </span>
                            </template>
                            <template v-else>
                                {{ item.actionInstruction }}
                            </template>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>


<script setup>
import { ref, computed, watch, onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import * as COMMONS from '../../store/_commons';
import { Tooltip } from 'floating-vue';
import '@/assets/tooltip.css';
import {formatWeekday, formatMonthDayYear, formatTime} from '../../utils/globalFilters'
import LinkOpenNewSr from '../../components/ui/LinkOpenNewSr.vue'

// Define emits to communicate with the parent component
const emit = defineEmits(['doRefresh']);

// Use the Vuex store
const store = useStore();

const router = useRouter(); 

// Reactive state for onlineToken
const onlineToken = ref('');

// Computed properties
const personalInfo = computed(() => store.getters[COMMONS.GUEST_PERSONAL_INFO]);
const mfaType = computed(() => store.state.guestLogin.mfaType);
const onlineTokenLocalStorage = computed(() => localStorage.getItem('onlineToken'));

// Watchers
watch(onlineToken, (value) => {
  if (value) {
    window.close();
  }
});

watch(onlineTokenLocalStorage, (value) => {
  if (value) {
    window.close();
  }
});

// Lifecycle hooks
onMounted(() => {
  window.addEventListener('storage', (event) => {
    if (event.key === 'onlineToken' && event.newValue) {
      window.close();
    }
  });
});

// Methods
const getPersonalProfileInformation = () => {
    store.dispatch(COMMONS.GUEST_PROFILE);
};

const splitInstructionForLink = (text) => {
  const phrase = "Insurance Revocation Reinstatement."
  if (!text) return { before: "", match: "", after: "" }

  const lowerText = text.toLowerCase()
  const lowerPhrase = phrase.toLowerCase()

  const index = lowerText.indexOf(lowerPhrase);
  if (index === -1) {
    return { before: text, match: "", after: "" }
  }

  const before = text.slice(0, index)
  const match = text.slice(index, index + phrase.length)  
  const after = text.slice(index + phrase.length)

  return { before, match, after }
};

const modifyReservation = (appointmentNumber) => {
    localStorage.setItem('confirmationNumber', appointmentNumber);
    localStorage.setItem('onlineToken', encodeURIComponent(store.state.guestLogin.accessToken));
    onlineToken.value = localStorage.getItem('onlineToken');
    window.open(`${window.config.WEB_CLIENT_URL}lookup?confirmationNumber=${appointmentNumber}&&onlineToken=${onlineToken.value}`);
};

const getRefresh = () => {
    getPersonalProfileInformation();
    emit('doRefresh');
};

const handleUpdateCommunicationClick = () => {
    if (personalInfo.value.personalInformation.isEmailVerified) {
    // If verified, navigate to UpdateCommunication page
    router.push({ name: 'UpdateCommunication' });
    }
    else {
        // Save destination in the store
        store.state.guestLogin.navigationSource = 'UpdateCommunication';
        // step for the contact
        store.state.guestLogin.contactUpdateStep = 1; 
        // Navigate
        router.push({ name: 'UpdateContacts' });
    }
};

const handleStandardContactUpdate = () => {
    // IMPORTANT: Clear the source so the "Paperless" div hides
    store.state.guestLogin.navigationSource = null;
    
    // Set the default step for standard updates
    store.state.guestLogin.contactUpdateStep = 1; 
    
    router.push({ name: 'UpdateContacts' });
};

// Lifecycle hooks
onUnmounted(() => {
    localStorage.removeItem('onlineToken');
    localStorage.removeItem('confirmationNumber');
});
</script>


<style scoped lang="scss">
.app-info {
    border-bottom: 1px solid var(--ri-gray);
    span, label {
        font-size: 1rem;
    }
    .app-notice {
        --whitespace: 1.5em;
        margin-bottom: var(--whitespace);
        max-width: 100%;
        p:first-child {
            @extend %font-sans-bold;
        }
        ul {
          li {
            list-style: initial;
            margin-bottom: calc(var(--whitespace) * 0.5);
          }
        }
        @supports (margin-block: 1em) {
          margin-block-end: var(--whitespace);
          ul {
            margin-inline-start: var(--whitespace);
            li {
              margin-block-end: calc(var(--whitespace) * 0.5);
            }
          }
        }
    }
    .res-display{
        display: flex;
        align-items: center;
    }
    .upcoming-res{
        margin-top: 1rem;
        .no-reservation{
            margin-bottom: 0.5rem;
        }
    }
    .app-reservations {
        display: block;
        .user-reservations{
            display: flex;
            flex-wrap: wrap;
            margin-top: 0.5rem;
            margin-bottom: 0.5rem;
        }
    }
    .res-notification{
        font-weight: bold;
    }
    .refresh-icon{
        margin-left: 10px;
        height: 30px;
    }
}
.app-info-row {
    display: flex;
    flex-wrap: wrap;
    gap: 1% 3%;
    .app-info-group {
        min-width: 150px;
        width: 14%;
        margin-bottom: 1.5rem;
        span {
            display: block;
            overflow-wrap: break-word;
        }
    }
    .user-res-details{
        min-width: 190px;
        margin-bottom: 0.5rem;

        .res-details {
            font-weight: bold;
            margin-bottom: 0.5rem;
        }
    }
}
@media only screen and (max-width: 600px) {
    .app-info-row {
        display: block;
        .user-res-details{
            min-width: 275px;
        }
    }
}
@media only screen and (max-width: 800px) {
    .active-icon {
        width: 25px;
        height: 25px;
        vertical-align: middle;
    }
    .blocks-info {
        margin-bottom: 1rem;
        margin-left: 0rem !important;
    }
    .app-notice{
        ul {
            li {
                margin-left: 1rem;
            }
        }
    }
}
.info-box {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem 3%;
    width: 100%;
    margin: 1rem auto;
    box-sizing: border-box;
    margin-bottom: 2rem;
    .user-info {
        width: 31%;
        overflow-wrap: break-word;    
        .user-address-info, .contact-info {
            font-weight: 600;
        }
        span {
            display: block;
            line-height: 30px;
            gap: 0.5rem;
        }
        h2 {
            font-size: 1.25rem;
        }   
        .user-info-sub-row {
            display: flex;
            gap: 1rem 3rem;
            flex-wrap: wrap;
        } 
        .verify-phone, .verify-email{
            display: flex;
            flex-wrap: wrap;
            .verify-icon{
                margin-left: 5px;
                width: 50px;
                height: 20px;
            }
            .user-info-email{
                display: block;
                width: 100%;
            }
        } 
        .comm-text {
            display: flex;
            font-weight: 600;
            .btn-tooltip-trigger{
                min-width: 25px;
                border: none;
                background-color: unset;
                border-radius: unset;
                padding: 0rem;
                .comm-tooltip{
                    width: 18px;
                    margin-bottom: -2px;
                }
            }
        }
        .app-communication {
            display: flex;
            gap: 0.5rem;
            .comm-notenrolled {
                color: green;
            }
        }

        .link-button {
            background: none;
            border: none;
            padding: 0;
            cursor: pointer;
            font: inherit;
            color: var(--ri-blue);
            text-decoration: underline;
            display: inline-block;  
            text-align: left;  
            &:hover{
                color: inherit;
                text-decoration: none;
            }
        }
    }
    @media only screen and (max-width: 600px) {
        .user-info {
            width: 100%;     
            .user-info-sub-row {
                display: block;
                .organ-donor {
                    padding-top: 10px;
                }
            } 
            .verify-phone, .verify-email{
                .verify-icon{
                    width: 50px;
                    height: 20px;
                }
            }
            .comm-text {
                display: flex;
                font-weight: 600;
            }
        }  
    }

    @media only screen and (min-width: 601px) and (max-width: 780px) {
        .user-info {    
            .app-communication {
                display: block;
            }
        }  
    }

    @media only screen and (min-width: 610px) and (max-width: 950px) {
        .user-info {  
            .verify-phone, .verify-email{
                .verify-icon{
                    width: 50px;
                    height: 20px;
                }
            }
            .comm-text {
            display: flex;
            font-weight: 600;
            .btn-tooltip-trigger{
                min-width: 25px;
                border: none;
                background-color: unset;
                border-radius: unset;
                padding: 0rem;
                .comm-tooltip{
                    width: 18px;
                    margin-bottom: -2px;
                }
            }
        }
        }  
    }
}
.active-icon {
    width: 25px;
    height: 25px;
    vertical-align: middle;
}
.blocks-info {
    display: flex;
    gap: 0.5rem;
    margin-bottom: 1rem;
    margin-left: -1rem;
    align-items: center;
}

.app-link-open {
    cursor: pointer;
    color: var(--ri-blue);
    &:focus {
        outline-color: #ff8e47;
    }
}
</style>